import React from "react";
import { useLang } from "../context/LanguageContext";
import { PageHeader } from "../components/common/PageHeader";
import { LanguageSwitcher } from "../components/common/LanguageSwitcher";
import { Switch } from "../components/ui/switch";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const SettingsRow = ({ title, desc, children, testId }) => (
  <div
    data-testid={testId}
    className="flex flex-col gap-3 border-b border-emerald-950/5 py-5 last:border-b-0 sm:flex-row sm:items-center sm:justify-between"
  >
    <div className="min-w-0">
      <div className="font-display text-sm font-semibold text-emerald-950">{title}</div>
      {desc && <div className="mt-0.5 text-xs text-emerald-900/60">{desc}</div>}
    </div>
    <div className="shrink-0">{children}</div>
  </div>
);

const SettingsPage = () => {
  const { t } = useLang();

  return (
    <div className="mx-auto max-w-4xl">
      <PageHeader title={t.settings.title} subtitle={t.settings.sub} testId="settings-page-header" showSampleBadge={false} />

      <div className="rounded-2xl border border-emerald-950/10 bg-white p-6" data-testid="settings-card">
        <SettingsRow
          testId="settings-language"
          title={t.settings.langLabel}
          desc="Switch between English and বাংলা. Applies instantly across the app."
        >
          <LanguageSwitcher />
        </SettingsRow>

        <SettingsRow
          testId="settings-notifications"
          title="Email notifications"
          desc="Receive daily operational digests (Phase 2)."
        >
          <Switch disabled data-testid="settings-notifications-toggle" />
        </SettingsRow>

        <SettingsRow
          testId="settings-twofa"
          title="Two-factor authentication"
          desc="Protect your account with OTP (Phase 2)."
        >
          <Switch disabled data-testid="settings-twofa-toggle" />
        </SettingsRow>

        <SettingsRow
          testId="settings-data"
          title="Data reset"
          desc="Clear local demo session data from this device."
        >
          <Button
            variant="outline"
            size="sm"
            data-testid="settings-reset-btn"
            onClick={() => {
              localStorage.removeItem("sarbajaya_demo_session");
              toast.success("Session reset. Reloading…");
              setTimeout(() => window.location.assign("/login"), 600);
            }}
            className="border-rose-300 text-rose-700 hover:bg-rose-50"
          >
            Reset demo session
          </Button>
        </SettingsRow>
      </div>

      <div className="mt-4 rounded-xl border border-amber-300/60 bg-amber-50 p-4 text-xs leading-relaxed text-amber-900">
        <strong>Phase 1 preview:</strong> Real authentication, multi-CLF role management, audit logs
        and WhatsApp sending will be implemented in subsequent phases. No real financial data is stored yet.
      </div>
    </div>
  );
};

export default SettingsPage;
